import { Component, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { SgAriaMessage } from '../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { Sgkd010dSearchResultComponent } from '../components/sgkd010d-search-result/sgkd010d-search-result.component';
import { SgKdConstants } from '../../../../sg-kd-shared/sg-kd-constants';
import { Sgkd030aResponseAccounttransferrequestReturninfo } from 'sg-api';

@Component({
  selector: 'app-sgkd010d',
  templateUrl: './sgkd010d.component.html',
  styleUrl: './sgkd010d.component.scss'
})
export class Sgkd010dComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject();

  @Output() errorMessageModelArray: Array<SgAriaMessage> = [];

  @ViewChild(Sgkd010dSearchResultComponent) resultComponent: Sgkd010dSearchResultComponent;

  /** メインフォーム */
  mainForm: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder) {
  }

  /**
   * 初期処理
   * 
   * @memberof Sgkd010dComponent
   */
  ngOnInit(): void {
    // メインフォームの生成
    this.mainForm = this.createMainForm();
  }

  /**
   * 破棄処理
   * 
   * @memberof Sgkd010dComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * メインFormの生成
   * 
   * @returns - メインForm
   * @memberof Sgkd010dComponent
   */
  private createMainForm(): UntypedFormGroup {
    return this.formBuilder.group({});
  }

  /**
   * メッセージ領域のクリア
   * 
   * @memberof Sgkd010dComponent
   */
  clearMessage(): void {
    this.errorMessageModelArray = [];
  }

  /**
   * インフォメッセージのメッセージエリアモデル作成
   * 
   * @param message インフォメッセージ
   * @memberof Sgkd010dComponent
   */
  pushSgAriaMessage(message: string): void {
    this.errorMessageModelArray.push({
      message: message,
      messageClass: SgKdConstants.MESSAGE.INFO.MESSAGE_CLS,
      icon: SgKdConstants.MESSAGE.INFO.ICON,
      iconClass: SgKdConstants.MESSAGE.INFO.ICON_CLS,
    });
  }

  /**
   * 検索結果設定処理
   * 
   * @param result 検索結果
   * @memberof Sgkd010dComponent
   */
  setResult(result: [Array<Sgkd030aResponseAccounttransferrequestReturninfo>, string]) {
    this.resultComponent.setResult(result[0], result[1]);
  }
}
